import { useState, useEffect } from "react";
import Loader from "../../../../Loader/Index";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { decryptCloudKeys } from "../../../../../redux/features/byok/byok";
import UniversalRefreshToast from "../../../../_utils/UniversalRefreshToast";
import { toast } from "react-toastify";
import TEXT from "../../../../../utils/globalText";
import TextInputField from "../../../../_utils/CommonInputFields/TextInputField";
import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import CommonToast from "../../../../_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const DeletePopup = ({
  deletePop,
  setDeletePop,
  selectKey,
  setCurrentDisplay,
  currentFetchedKey,
  setCanEncrypt,
  setByokProcessPending,
  setIsKeyDecrypted,
  setByokProcessFailed,
  setSelectKey,
  setBankingSelected,
  setIsUpdateKey,
}) => {
  const [inputText, setInputText] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  const [timeOutSD, setTimeOutSD] = useState(false);

  const {
    decryptionKeysGetLoading,
    decryptionKeysGetData,
    decryptionKeysGetError,
  } = useSelector((state) => state.byok);

  const dispatch = useDispatch();

  const enableConfirm = inputText === "Yes, delete";
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && enableConfirm) {
        handleEncryption();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [enableConfirm]);

  const handleEncryption = async () => {
    try {
      const response = await dispatch(
        decryptCloudKeys({
          values: selectKey || currentFetchedKey,
        }),
      );
      setTimeOutSD(true);
      const message = response.payload.message;
      if (message === "Decryption Queued successfully.") {
        UniversalRefreshToast("Data decryption is in process");
        setTimeout(() => {
          toast.dismiss();
          setDeletePop(false);
          // setByokProcessPending(true);
          setCanEncrypt(false);
          setCurrentDisplay("ByokDashboardPage");
          setIsKeyDecrypted(true);
          setByokProcessFailed(true);
          setTimeOutSD(false);
          setSelectKey("");
          setBankingSelected(false);
          setIsUpdateKey(false);

          CommonToast({
            text: "Setup deleted successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          window.location.reload();
        }, 3000);
      } else {
        setTimeOutSD(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={`byok-encryp-conf-popup ${deletePop ? "popup-show" : ""}`}>
      <div className="flex flex-col gap-gap-md w-full">
        <div className="flex flex-col gap-gap-sm">
          <div className="flex flex-row gap-gap-sm items-center">
            <img
              src={ICONS?.ALERT}
              className="w-icon-md h-icon-md"
              alt="alert-img"
            />
            <p className="text-error text-font-lg font-semibold">
              {TEXT?.DELETE_SETUP_CONFIRM}
            </p>
          </div>
          <p className="text-text-primary text-font-md font-normal">
            Once the process starts,{" "}
            <span className="text-failed">it cannot be aborted.</span>
          </p>
          <ul className="text-text-secondary text-font-sm font-normal flex flex-col gap-gap-sm list-disc pl-padding-md">
            <li>{TEXT?.DELETE_SETUP_DATA_WARNING}</li>
            <li>{TEXT?.DELETE_SETUP_ACTION_WARNING}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-gap-md">
          <p className="text-font-md font-normal text-text-primary">
            To confirm, kindly type{" "}
            <strong className="tracking-letter-space">“Yes, delete”</strong> in
            the input field below.
          </p>
          <div className="w-full">
            <TextInputField
              variant={enableConfirm ? "verified" : "default"}
              placeholder={"Enter text"}
              fontKind={"big"}
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              value={inputText}
              name={"Entertext"}
              onInput={(e) => {
                setInputText(e.target.value);
              }}
              isFullWidth={true}
            />
          </div>
        </div>
        <div className="flex flex-row gap-gap-sm justify-end">
          {!timeOutSD && (
            <PrimaryButton
              btnText={TEXT?.CANCEL}
              btnType="button"
              handleFunction={() => {
                setDeletePop(false);
                setInputText("");
                setIsFocus(false);
              }}
              enabledBgColor="var(--primary-card)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
            />
          )}
          {timeOutSD ? (
            <Loader />
          ) : (
            <PrimaryButton
              btnText={TEXT?.CONFIRM}
              btnType="button"
              handleFunction={handleEncryption}
              isDisabled={!enableConfirm}
              enabledBgColor="var(--Button-green)"
              disabledBgColor="var(--text-secondary)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
